<ng-template #moduleEdit let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Edit</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="card">
				<div class="card-header text-center">
					<h4 class="card-title">Edit Module</h4>
				</div>
				<div class="card">
					<div class="card-body">
						<form [formGroup]="moduleForm">
							<div class="row mt-2">
								<div class="col-md-3">
									<mat-form-field appearance="outline">
										<mat-label>Heading Title</mat-label>
										<input matInput required value="" formControlName="name">
									</mat-form-field>
								</div>
								<div class="col-md-12">
									<label for="description-editor" class="form-label small">Description</label>
									<app-wysiwyg-editor [input]="descCtrl" (data)="updateForm(descCtrl, $event)"></app-wysiwyg-editor>
								</div>
								
							</div>
						</form>
					</div>
				</div>
				<div class="card-footer text-muted text-center">
					<button mat-raised-button color="primary" (click)="saveModule()">Save Module</button>
				</div>
			</div>

		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<button mat-stroked-button color="success" aria-label="" (click)="addModule()" class="mt-2 mb-2">
	<mat-icon>add</mat-icon> Add Module
</button>

<table class="table table-striped table-hover table-bordered">
	<thead class="thead-dark">
		<tr>
			<th scope="col">Module ID</th>
			<th scope="col">Name</th>
			<th scope="col">Code</th>
			<th scope="col" class="text-center">Edit/Remove</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let s of modules">
			<td>{{ s.module_id }}</td>
			<td [innerHTML]="s.name"></td>
			<td>{{ s.code }}</td>
			<td class="text-center">
				<button mat-icon-button color="primary" (click)="editModule(s)">
					<mat-icon>edit</mat-icon>
				</button>
				&nbsp;&nbsp;
				<button mat-icon-button color="warn" (click)="removeModule(s)">
					<mat-icon>delete</mat-icon>
				</button>
			</td>
		</tr>
	</tbody>
</table>
